import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { Button, makeStyles } from "@material-ui/core";
import StopIcon from "@material-ui/icons/Stop";
import RoomContext from "../../context/RoomContext";

const useStyles = makeStyles(() => ({
  bar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: "100%",
    boxSizing: "border-box",
    padding: "8px 10px",
    borderRadius: 12,
    background: "rgba(15, 23, 42, 0.88)",
    border: "1px solid rgba(148, 163, 184, 0.35)",
    backdropFilter: "blur(8px)",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.28)",
    marginBottom: 8,
  },
  miniBar: {
    gap: 4,
    padding: "4px 6px",
    borderRadius: 8,
    marginBottom: 4,
  },
  btn: {
    textTransform: "none",
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 1.2,
    borderRadius: 8,
    padding: "6px 12px",
    minHeight: 32,
    color: "#fecaca",
    borderColor: "rgba(248, 113, 113, 0.55)",
    background: "rgba(227, 59, 74, 0.22)",
    "&:hover": {
      background: "rgba(227, 59, 74, 0.38)",
      borderColor: "#f87171",
    },
    "& .MuiButton-startIcon": {
      marginRight: 6,
    },
  },
  miniBtn: {
    fontSize: 10,
    padding: "4px 8px",
    minHeight: 26,
  },
}));

const RemoteControlHostActions = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { roomClient } = useContext(RoomContext);
  const meId = useSelector((state) => state.me.id);
  const isMini = useSelector((state) => state.call.displayMini);
  const session = useSelector((state) => state.remoteControl);

  if (
    !session ||
    session.status !== "active" ||
    session.hostPeerId !== meId
  ) {
    return null;
  }

  const label = intl.formatMessage({
    id: "remoteControl.reclaim",
    defaultMessage: "Take back control",
  });

  return (
    <div className={`${classes.bar} ${isMini ? classes.miniBar : ""}`}>
      <Button
        variant="outlined"
        size="small"
        className={`${classes.btn} ${isMini ? classes.miniBtn : ""}`}
        startIcon={<StopIcon fontSize="small" />}
        aria-label={label}
        onClick={() => roomClient.endRemoteControl()}
      >
        {label}
      </Button>
    </div>
  );
};

export default RemoteControlHostActions;
